import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DisplayState } from '../../../../shared/enums/signaturit/signaturit-enums';
import { NotificationService } from '../../../../base/services/notification/notification-service';

@Component({
  selector: 'signaturit-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit, OnDestroy {

  @Input() customText: string = '';
  @Input() timer: number = 0;

  containerNotif: HTMLElement;
  type: string = DisplayState.SUCCESS;


  constructor(private notification: NotificationService) { }

  ngOnInit(): void {
    this.applyStyle();
    this.onOpen();

    if (this.timer > 0) {
      this.notification.setTimeNotif(this.timer * 1000);
    }
  }

  ngOnDestroy(): void {
    this.notification.clearConfig();
  }

  applyStyle(): void {
    this.containerNotif = document.getElementById('containerNotification');
    switch (this.type) {
      case DisplayState.SUCCESS:
        this.containerNotif.className = 'successStyles';
        break;
      case DisplayState.ERROR:
        this.containerNotif.className = 'errorStyles';
        break;
      case DisplayState.WARNING:
        break;
    }
  }

  closeMenu(): void {
    this.notification.clearConfig();
  }

  setInterval(): void {
    this.notification.setTimeNotif(this.timer);
  }

  onOpen(): void {
    this.notification.isActive.subscribe((response: boolean) => {
      this.type = this.notification.type;
      if (response) {
        this.applyStyle();
        this.containerNotif.style.display = 'flex';
        if(!this.customText){
          this.customText = this.notification.textNotif;
        }
      } else {
        this.containerNotif.style.display = 'none';
      }
    })
  }

}
